import React from 'react';
import AdminQuestionnairesList from '../../components/Admin/AdminQuestionnairesList';

export const AdminQuestionnaires = () => {
  return <AdminQuestionnairesList />;
};

export default AdminQuestionnaires;
